<section class="astral-stack-l" aria-live="polite">
  @if (loading) {
    <app-information-block [text]="'COMPANY.BANK_ACCOUNT.LOADING' | translate"></app-information-block>
  } @else if (loadFailed) {
    <div class="astral-stack-m">
      <app-information-block [text]="'COMPANY.BANK_ACCOUNT.LOAD_FAILED' | translate"></app-information-block>
      <astral-button variant="secondary" size="small" type="button" labelKey="COMMON.TRY_AGAIN" (click)="loadAccounts()"></astral-button>
    </div>
  } @else {
    @if (bankAccounts.length === 0) {
      <app-information-block [text]="'COMPANY.BANK_ACCOUNT.EMPTY' | translate"></app-information-block>
    } @else {
      <div class="astral-stack-m">
        @for (account of bankAccounts; track account.id) {
          <section class="astral-section-surface astral-section-surface--compact astral-stack-m">
            <div class="astral-section-header">
              <div>
                <h4>{{ account.name }}</h4>
                <p>{{ bankName(account) || ('COMPANY.BANK_ACCOUNT.BANK_UNKNOWN' | translate) }}</p>
              </div>
              <astral-button variant="secondary" size="small" type="button" labelKey="EDIT_BTN" (click)="openEdit(account)"></astral-button>
            </div>

            @if (account.defaultInvoiceAccount) {
              <app-information-block [text]="'COMPANY.BANK_ACCOUNT.INVOICING_ACCOUNT_INFO' | translate"></app-information-block>
            }

            <astral-layout-group [columns]="3" [tabletColumns]="2" [mobileColumns]="1">
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.ACCOUNTING_ACCOUNT' | translate }}</strong><br />{{ account.accountingAccountNumber }} {{ account.accountingAccountName }}</div>
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.ACCOUNT_NO' | translate }}</strong><br />{{ accountNumber(account) || '–' }}</div>
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.BANKGIRO_NUMBER' | translate }}</strong><br />{{ account.bankGiroNumber || '–' }}</div>
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.IBAN' | translate }}</strong><br />{{ account.iban || '–' }}</div>
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.BIC' | translate }}</strong><br />{{ account.bic || '–' }}</div>
              <div><strong>{{ 'COMPANY.BANK_ACCOUNT.CUSTOMER_NUMBER' | translate }}</strong><br />{{ account.customerNumber || '–' }}</div>
              <div>
                <strong>{{ 'BANK_IMPORT_TRANSACTIONS.IMPORT_FROM_DATE' | translate }}</strong><br />
                @if (account.bankTransactionsImportStartDate?.hasValue()) {
                  <app-date-box [value]="account.bankTransactionsImportStartDate.toDate()"></app-date-box>
                } @else {
                  –
                }
              </div>
            </astral-layout-group>
          </section>
        }
      </div>
    }

    <astral-button variant="primary" size="small" type="button" icon="plus" labelKey="COMPANY.BANK_ACCOUNT.ADD_ACCOUNT" (click)="openCreate()"></astral-button>
  }
</section>

<ng-template #bankAccountSidebar>
  @if (selectedAccount) {
    <app-company-bank-account
      [banks]="banks"
      [company]="company"
      [accountPlanId]="accountPlanId"
      [companyBankAccount]="selectedAccount"
      (saved)="onAccountSaved()"
      (deleted)="onAccountDeleted()"
      (cancelled)="closeEditor()"
    ></app-company-bank-account>
  }
</ng-template>
